import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    userInfo: {},
    lang: {
      en: {
        creaAC: 'Create Activity',
        setDocumentTitle: 'activity',
        sub: 'Subscribe',
        noAc: 'There is currently no room activity, go to create it！',
        create: 'Create',

        theme: 'Activity Theme',
        desc: 'Activity Description',
        time: 'Activity Time',
        st: 'Start Time',
        duration: 'Duration',
        cancel: 'cancel',
        canceled: 'Canceled',
        confirm: 'confirm',
        y: 'year',
        m: 'month',
        d: 'day',
        h: 'hour',
        mi: 'minute',
        sel: 'Please select',
        input: 'Please enter',
        next: 'Next',
        back: 'Back',
        publish: 'Publish',
        gold: 'gold',

        mySub: 'My Subscriptions',
        myPub: 'My Publishing',
        notStart: 'Not started yet',
        ongoing: 'Room in progress',
        done: 'Ended',
        review: 'Under review',
        noPass: 'Review failed',
        yes: 'Confirm',
        no: 'Cancel',
        noRoom1: 'There are currently no rooms available, go subscribe now!',
        noRoom2: 'There are currently no rooms available, go and publish them now!',
        desc1: 'Cancel the event, your room will be removed from the list, are you sure to cancel?',
        desc2:
          'If you cancel within 24 hours from the start time, gold coins will not be returned. Are you sure you want to cancel?',
        errorImgUP: 'The upload failed, please log in again',
        Suc1: 'Canceled successfully',
        Suc2: 'Created successfully',
        Suc3: 'Subscription successful',
        please: 'Please complete the information'
      },
      tr: {
        creaAC: 'Etkinlik Oluştur',
        setDocumentTitle: 'Etkinlik',
        // sub: "Bağışta Bulunmak",
        sub: 'Oluştur',
        noAc: 'Şu anda oda etkinliği yok, oluşturmak için git',
        create: 'Etkinlik Oluştur',

        theme: 'Etkinlik Teması',
        desc: 'Etkinlik Açıklaması',
        time: 'Etkinlik Zamanı',
        st: 'Başlangıç Zamanı',
        duration: 'Süre',
        cancel: 'Iptal etmek',
        canceled: 'İptal edildi',
        confirm: 'Doğrula',
        y: 'Yıl',
        m: 'Ay',
        d: 'Gün',
        h: 'Saat',
        mi: 'Dakika',
        sel: 'Lütfen seçin',
        input: 'Lütfen girin',
        next: 'Sonraki',
        back: 'Geri',
        publish: 'Yayınla',
        gold: 'Altın',
        mySub: 'Abone Olduklarım',
        myPub: 'Yayınlanan',
        notStart: 'Henüz başlamadı',
        ongoing: 'Oda devam ediyor',
        done: 'Bitti',
        review: 'İnceleniyor',
        noPass: 'İnceleme başarısız oldu',
        yes: 'Doğrula',
        no: 'Iptal et',
        noRoom1: 'Şu anda müsait oda yok, gidin hemen abone olun!',
        noRoom2: 'Şu anda müsait oda yok, gidin ve şimdi yayınlayın!',
        desc1: 'Etkinliği iptal ederseniz, odanız listeden kaldırılacak, iptal ettiğinizden emin misiniz?',
        desc2:
          'Başlangıç saatinden itibaren 24 saat içinde iptal ederseniz, altınlar iade edilmeyecektir. İptal etmek istediğinizden emin misiniz?',
        errorImgUP: 'Yükleme başarısız oldu, lütfen tekrar giriş yapın',
        Suc1: 'Başarıyla iptal edildi',
        Suc2: 'Başarıyla oluşturuldu',
        Suc3: 'Abonelik başarılı',
        please: 'Lütfen bilgileri tamamlayın'
      },
      ar: {
        creaAC: 'إنشاء نشاط',
        setDocumentTitle: 'النشاط',
        sub: 'الاشتراكات',
        noAc: ' لا يوجد نشاط للغرفة حاليًا ، انتقل لإنشائه',
        create: 'إنشاء ',
        theme: ' موضوع النشاط',
        desc: 'وصف النشاط',
        time: 'وقت النشاط',
        st: 'وقت البدء',
        duration: 'مدة',
        cancel: 'يلغي',
        canceled: 'ألغيت',
        confirm: 'يتأكد',
        y: 'سنة',
        m: 'شهر',
        d: 'يوم',
        h: 'ساعة',
        mi: 'دقيقة',
        sel: 'الرجاء التحديد',
        input: 'تفضل',
        next: 'التالي',
        back: 'السابق',
        publish: 'ينشر',
        gold: 'ذهب',

        mySub: 'اشتراكاتي',
        myPub: 'النشر الخاص بي',
        notStart: 'لم تبدأ بعد',
        ongoing: 'الغرفة قيد التقدم',
        done: 'انتهى',
        review: 'قيد المراجعة',
        noPass: 'فشلت المراجعة',
        yes: 'يتأكد',
        no: 'يلغي',
        noRoom1: 'لا يوجد غرف متاحة حاليا ، إشترك الآن!',
        noRoom2: 'لا توجد غرف متاحة حاليًا ، اذهب وانشرها الآن!',
        desc1: 'إلغاء الحدث ، ستتم إزالة غرفتك من القائمة ، هل أنت متأكد من الإلغاء؟',
        desc2:
          'إذا قمت بالإلغاء خلال 24 ساعة من وقت البدء ، فلن يتم إرجاع العملات الذهبية. هل أنت متأكد أنك تريد إلغاء؟',
        errorImgUP: 'فشل التحميل ، يرجى تسجيل الدخول مرة أخرى',
        Suc1: 'إلغاء النجاح',
        Suc2: 'تم إنشاءها بنجاح',
        Suc3: 'نجاح الإشتراك',
        please: 'يرجي إستكمال المعلومات'
      },
      ru: {
        creaAC: 'Создать активность',
        setDocumentTitle: 'активность',
        sub: 'Подписаться',
        noAc: 'В настоящее время нет активности в комнате, создайте её!',
        create: 'Создать',
        theme: 'Тема активности',
        desc: 'Описание активности',
        time: 'Время активности',
        st: 'Время начала',
        duration: 'Продолжительность',
        cancel: 'отменить',
        canceled: 'Отменено',
        confirm: 'подтвердить',
        y: 'год',
        m: 'месяц',
        d: 'день',
        h: 'час',
        mi: 'минута',
        sel: 'Пожалуйста, выберите',
        input: 'Пожалуйста, введите',
        next: 'Далее',
        back: 'Назад',
        publish: 'Опубликовать',
        gold: 'золото',
        mySub: 'Мои подписки',
        myPub: 'Мои публикации',
        notStart: 'Ещё не началось',
        ongoing: 'Комната в процессе',
        done: 'Завершено',
        review: 'На рассмотрении',
        noPass: 'Проверка не пройдена',
        yes: 'Подтвердить',
        no: 'Отменить',
        noRoom1: 'В настоящее время нет доступных комнат, подпишитесь сейчас!',
        noRoom2: 'В настоящее время нет доступных комнат, опубликуйте их сейчас!',
        desc1: 'Отменить мероприятие, ваша комната будет удалена из списка, вы уверены, что хотите отменить?',
        desc2:
          'Если вы отмените в течение 24 часов с момента начала, золотые монеты не будут возвращены. Вы уверены, что хотите отменить?',
        errorImgUP: 'Загрузка не удалась, пожалуйста, войдите снова',
        Suc1: 'Успешно отменено',
        Suc2: 'Успешно создано',
        Suc3: 'Подписка успешна',
        please: 'Пожалуйста, заполните информацию'
      },

      id: {
        creaAC: 'Buat Aktivitas',
        setDocumentTitle: 'aktivitas',
        sub: 'Berlangganan',
        noAc: 'Saat ini tidak ada aktivitas ruangan, buat sekarang!',
        create: 'Buat',
        theme: 'Tema Aktivitas',
        desc: 'Deskripsi Aktivitas',
        time: 'Waktu Aktivitas',
        st: 'Waktu Mulai',
        duration: 'Durasi',
        cancel: 'batal',
        canceled: 'Dibatalkan',
        confirm: 'konfirmasi',
        y: 'tahun',
        m: 'bulan',
        d: 'hari',
        h: 'jam',
        mi: 'menit',
        sel: 'Silakan pilih',
        input: 'Silakan masukkan',
        next: 'Berikutnya',
        back: 'Kembali',
        publish: 'Publikasikan',
        gold: 'emas',
        mySub: 'Langganan Saya',
        myPub: 'Publikasi Saya',
        notStart: 'Belum dimulai',
        ongoing: 'Sedang berlangsung',
        done: 'Berakhir',
        review: 'Dalam tinjauan',
        noPass: 'Tinjauan gagal',
        yes: 'Konfirmasi',
        no: 'Batal',
        noRoom1: 'Saat ini tidak ada ruangan yang tersedia, berlangganan sekarang!',
        noRoom2: 'Saat ini tidak ada ruangan yang tersedia, publikasikan sekarang!',
        desc1: 'Batalkan acara, ruangan Anda akan dihapus dari daftar, yakin ingin membatalkan?',
        desc2:
          'Jika Anda membatalkan dalam waktu 24 jam dari waktu mulai, koin emas tidak akan dikembalikan. Yakin ingin membatalkan?',
        errorImgUP: 'Unggahan gagal, silakan masuk kembali',
        Suc1: 'Berhasil dibatalkan',
        Suc2: 'Berhasil dibuat',
        Suc3: 'Berlangganan berhasil',
        please: 'Harap lengkapi informasi'
      },
      uz: {
        creaAC: 'Faollik yaratish',
        setDocumentTitle: 'faollik',
        sub: "Obuna bo'lish",
        noAc: "Hozircha xonada faollik yo'q, yarating!",
        create: 'Yaratish',
        theme: 'Faollik mavzusi',
        desc: 'Faollik tavsifi',
        time: 'Faollik vaqti',
        st: 'Boshlanish vaqti',
        duration: 'Davomiylik',
        cancel: 'bekor qilish',
        canceled: 'Bekor qilindi',
        confirm: 'tasdiqlash',
        y: 'yil',
        m: 'oy',
        d: 'kun',
        h: 'soat',
        mi: 'daqiqa',
        sel: 'Iltimos, tanlang',
        input: 'Iltimos, kiriting',
        next: 'Keyingi',
        back: 'Orqaga',
        publish: 'Nashr qilish',
        gold: 'oltin',
        mySub: 'Mening obunalarim',
        myPub: 'Mening nashrlarim',
        notStart: 'Hali boshlanmadi',
        ongoing: 'Jarayonda',
        done: 'Tugadi',
        review: "Ko'rib chiqilmoqda",
        noPass: "Ko'rib chiqish muvaffaqiyatsiz",
        yes: 'Tasdiqlash',
        no: 'Bekor qilish',
        noRoom1: "Hozircha mavjud xonalar yo'q, hozir obuna bo'ling!",
        noRoom2: "Hozircha mavjud xonalar yo'q, hozir nashr qiling!",
        desc1: "Tadbirni bekor qilish, xonangiz ro'yxatdan o'chiriladi, bekor qilishni tasdiqlaysizmi?",
        desc2:
          'Agar boshlanish vaqtidan 24 soat ichida bekor qilsangiz, oltin tangalar qaytarilmaydi. Bekor qilishni tasdiqlaysizmi?',
        errorImgUP: 'Yuklash muvaffaqiyatsiz, iltimos, qayta kiring',
        Suc1: 'Muvaffaqiyatli bekor qilindi',
        Suc2: 'Muvaffaqiyatli yaratildi',
        Suc3: "Muvaffaqiyatli obuna bo'ldi",
        please: "Iltimos, ma'lumotlarni to'ldiring"
      },

      fa: {
        creaAC: 'ایجاد فعالیت',
        setDocumentTitle: 'فعالیت',
        sub: 'اشتراک',
        noAc: 'در حال حاضر هیچ فعالیتی در اتاق وجود ندارد، آن را ایجاد کنید!',
        create: 'ایجاد',
        theme: 'موضوع فعالیت',
        desc: 'توضیحات فعالیت',
        time: 'زمان فعالیت',
        st: 'زمان شروع',
        duration: 'مدت زمان',
        cancel: 'لغو',
        canceled: 'لغو شد',
        confirm: 'تایید',
        y: 'سال',
        m: 'ماه',
        d: 'روز',
        h: 'ساعت',
        mi: 'دقیقه',
        sel: 'لطفا انتخاب کنید',
        input: 'لطفا وارد کنید',
        next: 'بعدی',
        back: 'بازگشت',
        publish: 'انتشار',
        gold: 'طلا',
        mySub: 'اشتراک‌های من',
        myPub: 'انتشارات من',
        notStart: 'هنوز شروع نشده',
        ongoing: 'در حال انجام',
        done: 'پایان یافت',
        review: 'در حال بررسی',
        noPass: 'بررسی ناموفق',
        yes: 'تایید',
        no: 'لغو',
        noRoom1: 'در حال حاضر هیچ اتاقی موجود نیست، اکنون مشترک شوید!',
        noRoom2: 'در حال حاضر هیچ اتاقی موجود نیست، اکنون منتشر کنید!',
        desc1: 'رویداد را لغو کنید، اتاق شما از لیست حذف خواهد شد، آیا مطمئن هستید که می‌خواهید لغو کنید؟',
        desc2:
          'اگر در عرض 24 ساعت از زمان شروع لغو کنید، سکه‌های طلا بازگردانده نمی‌شوند. آیا مطمئن هستید که می‌خواهید لغو کنید؟',
        errorImgUP: 'آپلود ناموفق بود، لطفا دوباره وارد شوید',
        Suc1: 'با موفقیت لغو شد',
        Suc2: 'با موفقیت ایجاد شد',
        Suc3: 'اشتراک با موفقیت انجام شد',
        please: 'لطفا اطلاعات را تکمیل کنید'
      },

      ur: {
        creaAC: 'سرگرمی بنائیں',
        setDocumentTitle: 'سرگرمی',
        sub: 'سبسکرائب کریں',
        noAc: 'فی الحال کوئی روم سرگرمی موجود نہیں، ابھی بنائیں!',
        create: 'بنائیں',
        theme: 'سرگرمی کا موضوع',
        desc: 'سرگرمی کی تفصیل',
        time: 'سرگرمی کا وقت',
        st: 'شروع کا وقت',
        duration: 'دورانیہ',
        cancel: 'منسوخ کریں',
        canceled: 'منسوخ ہوگیا',
        confirm: 'تصدیق کریں',
        y: 'سال',
        m: 'مہینہ',
        d: 'دن',
        h: 'گھنٹہ',
        mi: 'منٹ',
        sel: 'براہ کرم منتخب کریں',
        input: 'براہ کرم درج کریں',
        next: 'اگلا',
        back: 'پیچھے',
        publish: 'شائع کریں',
        gold: 'سونا',
        mySub: 'میری سبسکرپشنز',
        myPub: 'میری اشاعتیں',
        notStart: 'ابھی شروع نہیں ہوا',
        ongoing: 'جاری ہے',
        done: 'ختم ہوگیا',
        review: 'جائزے میں',
        noPass: 'جائزہ ناکام',
        yes: 'تصدیق کریں',
        no: 'منسوخ کریں',
        noRoom1: 'فی الحال کوئی روم دستیاب نہیں، ابھی سبسکرائب کریں!',
        noRoom2: 'فی الحال کوئی روم دستیاب نہیں، ابھی شائع کریں!',
        desc1: 'سرگرمی منسوخ کریں، آپ کا روم فہرست سے ہٹا دیا جائے گا، کیا آپ واقعی منسوخ کرنا چاہتے ہیں؟',
        desc2:
          'اگر آپ شروع کے وقت سے 24 گھنٹے کے اندر منسوخ کریں گے، تو سونے کے سکے واپس نہیں کیے جائیں گے۔ کیا آپ واقعی منسوخ کرنا چاہتے ہیں؟',
        errorImgUP: 'اپ لوڈ ناکام ہوا، براہ کرم دوبارہ لاگ ان کریں',
        Suc1: 'کامیابی سے منسوخ ہوگیا',
        Suc2: 'کامیابی سے بن گیا',
        Suc3: 'کامیابی سے سبسکرائب ہوگیا',
        please: 'براہ کرم معلومات مکمل کریں'
      },

      pt: {
        creaAC: 'Criar Atividade',
        setDocumentTitle: 'atividade',
        sub: 'Assinar',
        noAc: 'Atualmente não há atividade na sala, crie uma agora!',
        create: 'Criar',
        theme: 'Tema da Atividade',
        desc: 'Descrição da Atividade',
        time: 'Horário da Atividade',
        st: 'Hora de Início',
        duration: 'Duração',
        cancel: 'cancelar',
        canceled: 'Cancelado',
        confirm: 'confirmar',
        y: 'ano',
        m: 'mês',
        d: 'dia',
        h: 'hora',
        mi: 'minuto',
        sel: 'Por favor selecione',
        input: 'Por favor insira',
        next: 'Próximo',
        back: 'Voltar',
        publish: 'Publicar',
        gold: 'ouro',
        mySub: 'Minhas Assinaturas',
        myPub: 'Minhas Publicações',
        notStart: 'Ainda não começou',
        ongoing: 'Em andamento',
        done: 'Terminado',
        review: 'Em revisão',
        noPass: 'Revisão falhou',
        yes: 'Confirmar',
        no: 'Cancelar',
        noRoom1: 'Atualmente não há salas disponíveis, assine agora!',
        noRoom2: 'Atualmente não há salas disponíveis, publique agora!',
        desc1: 'Cancelar o evento, sua sala será removida da lista, tem certeza que deseja cancelar?',
        desc2:
          'Se você cancelar dentro de 24 horas do horário de início, as moedas de ouro não serão devolvidas. Tem certeza que deseja cancelar?',
        errorImgUP: 'Upload falhou, por favor faça login novamente',
        Suc1: 'Cancelado com sucesso',
        Suc2: 'Criado com sucesso',
        Suc3: 'Assinatura bem-sucedida',
        please: 'Por favor complete as informações'
      }
    },
    datePickerLocale: {
      en: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        am: 'AM',
        pm: 'PM'
      },
      tr: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        am: 'AM',
        pm: 'PM'
      },
      ar: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        am: 'صباحا',
        pm: 'مساء'
      },
      ru: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        am: 'AM',
        pm: 'PM'
      },
      id: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        am: 'AM',
        pm: 'PM'
      },
      uz: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        am: 'AM',
        pm: 'PM'
      },
      fa: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        am: 'صبح',
        pm: 'عصر'
      },
      ur: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        am: 'AM',
        pm: 'PM'
      },
      pt: {
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        am: 'AM',
        pm: 'PM'
      }
    }
  }

  @action async GetUserInfoWeb(uid) {
    let resParams = await http.post('/web/MyAccountInfo', { uid: uid })
    this.data.userInfo = resParams.res
    return resParams
  }

  // 房间活动列表1
  @action async apiGetPartyRoomList() {
    let data = await http.post('/web/group/activity/list')
    return data
  }
  // 订阅列表1
  @action async apiGetSubList() {
    let data = await http.post('/web/group/activity/subscribe/list')
    return data
  }
  // 发布列表1
  @action async apiGetPubList() {
    let data = await http.post('/web/group/activity/publish/list')
    return data
  }
  // 详情1
  @action async apiGetPubDetail(id) {
    let data = await http.post('/web/group/activity/details', { id })
    return data
  }
  // 图片列表1
  @action async apiGetImageList() {
    let data = await http.post('/web/group/activity/image/list')
    return data
  }

  // 订阅房间1
  @action async apiHandleSubRoom(id) {
    let data = await http.post('/web/group/activity/subscribe', { id })
    return data
  }
  // 取消订阅房间1
  @action async apiHandleUnSubRoom(id) {
    let data = await http.post('/web/group/activity/unsubscribe', { id })
    return data
  }

  // 发布房间1
  @action async apiHandlePubRoom({ name, description, imageId, image, startTime, duration }) {
    let data = await http.post('/web/group/activity/publish', {
      name,
      description,
      imageId,
      image,
      startTime,
      duration
    })
    return data
  }
  // 取消房间1
  @action async apiHandleCancelRoom(id) {
    let data = await http.post('/web/group/activity/unpublish', { id })
    return data
  }

  // 上传参数
  @action async apiGetUploadParams() {
    let data = await http.post('/web/oss/upload  ')
    return data
  }
}



// WEBPACK FOOTER //
// src/store/app/partyStore.js